/**
 * CCTV 기기 서비스
 */

import apiClient from './api';
import {
  CctvDevice,
  CctvDeviceFilter,
  CctvDeviceListResponse,
} from '../types/cctv';

export const cctvService = {
  /**
   * CCTV 기기 목록 조회
   */
  async getDevices(filter: CctvDeviceFilter = {}): Promise<CctvDeviceListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: CctvDeviceListResponse }>(`/admin/cctv/devices?${params.toString()}`);
    // return response.data.data;

    return {
      devices: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * CCTV 기기 상세 조회
   */
  async getDevice(id: number): Promise<CctvDevice> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * CCTV 기기 등록
   */
  async createDevice(data: Partial<CctvDevice>): Promise<CctvDevice> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * CCTV 기기 수정
   */
  async updateDevice(id: number, data: Partial<CctvDevice>): Promise<CctvDevice> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * CCTV 기기 삭제
   */
  async deleteDevice(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * CCTV 스트림 URL 조회
   */
  async getStreamUrl(deviceId: number): Promise<string> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { stream_url: string } }>(`/admin/cctv/devices/${deviceId}/stream`);
    // return response.data.data.stream_url;

    throw new Error('Not implemented');
  },
};

